const strictConstellationAspects = {
    "合": {
        0: [0],
        1: [1],
        2: [2],
        3: [3],
        4: [4],
        5: [5],
        6: [6],
        7: [7],
        8: [8],
        9: [9],
        10: [10],
        11: [11]
    },
    "冲": {
        0: [6],
        1: [7],
        2: [8],
        3: [9],
        4: [10],
        5: [11],
        6: [0],
        7: [1],
        8: [2],
        9: [3],
        10: [4],
        11: [5]
    },
    "拱": {
        0: [4, 8],
        1: [5, 9],
        2: [6, 10],
        3: [7, 11],
        4: [8, 0],
        5: [9, 1],
        6: [10, 2],
        7: [11, 3],
        8: [0, 4],
        9: [1, 5],
        10: [2, 6],
        11: [3, 7]
    },
    "刑": {
        0: [3, 9],
        1: [4, 10],
        2: [5, 11],
        3: [6, 0],
        4: [7, 1],
        5: [8, 2],
        6: [9, 3],
        7: [10, 4],
        8: [11, 5],
        9: [0, 6],
        10: [1, 7],
        11: [2, 8]
    }
};

export default strictConstellationAspects;



// const mapping = {
//   "合": {
//     "牡羊": ["牡羊"],
//     "金牛": ["金牛"],
//     "雙子": ["雙子"],
//     "巨蟹": ["巨蟹"],
//     "獅子": ["獅子"],
//     "處女": ["處女"],
//     "天秤": ["天秤"],
//     "天蠍": ["天蠍"],
//     "射手": ["射手"],
//     "摩羯": ["摩羯"],
//     "水瓶": ["水瓶"],
//     "雙魚": ["雙魚"]
//   },
//   "冲": {
//     "牡羊": ["天秤"],
//     "金牛": ["天蠍"],
//     "雙子": ["射手"],
//     "巨蟹": ["摩羯"],
//     "獅子": ["水瓶"],
//     "處女": ["雙魚"],
//     "天秤": ["牡羊"],
//     "天蠍": ["金牛"],
//     "射手": ["雙子"],
//     "摩羯": ["巨蟹"],
//     "水瓶": ["獅子"],
//     "雙魚": ["處女"]
//   },
//   "拱": {
//     "牡羊": ["獅子", "射手"],
//     "金牛": ["處女", "摩羯"],
//     "雙子": ["天秤", "水瓶"],
//     "巨蟹": ["天蠍", "雙魚"],
//     "獅子": ["射手", "牡羊"],
//     "處女": ["摩羯", "金牛"],
//     "天秤": ["水瓶", "雙子"],
//     "天蠍": ["雙魚", "巨蟹"],
//     "射手": ["牡羊", "獅子"],
//     "摩羯": ["金牛", "處女"],
//     "水瓶": ["雙子", "天秤"],
//     "雙魚": ["巨蟹", "天蠍"]
//   },
//   "刑": {
//     "牡羊": ["巨蟹", "摩羯"],
//     "金牛": ["獅子", "水瓶"],
//     "雙子": ["處女", "雙魚"],
//     "巨蟹": ["天秤", "牡羊"],
//     "獅子": ["天蠍", "金牛"],
//     "處女": ["射手", "雙子"],
//     "天秤": ["摩羯", "巨蟹"],
//     "天蠍": ["水瓶", "獅子"],
//     "射手": ["雙魚", "處女"],
//     "摩羯": ["牡羊", "天秤"],
//     "水瓶": ["金牛", "天蠍"],
//     "雙魚": ["雙子", "射手"]
//   }
// };
